import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";
import Users from "../../../pages/easymerch/users/users";

import "../../../scss/App.scss";
import { IUserOptions } from '../../../types/interfaces';

const UsersApp = () => {

  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="Easy Merch"
        title="Физ. лица"
        headBlockChildren={
          <>
          {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <HeaderBtn
            modalTitle="Отправить маршруты в Easy Merch"
            content="Отправить маршруты в Easy Merch"
            purpose="sendRoutesToEasyMerch"
          />}
          </>
        }
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/outlets" className="tab">
              <div className="buttons__btn">Торговые точки</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/report" className="tab">
              <div className="buttons__btn">Типы отчетов</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/users" className="tab">
              <div className="buttons__btn --active">Физ. лица</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/service-types" className="tab">
              <div className="buttons__btn">Типы обслуживания</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/integration-errors" className="tab">
              <div className="buttons__btn">Ошибки интеграции</div>
            </Link>}
          </div>
          <Users />
        </div>
      </SectionContent>
    </div>
  );
};

export default UsersApp;
